/* Tice Nits: landingspagina's. Filterknoppen boven de productkaarten. Zonder JS staan alle producten er. */
(() => {
  function init(root) {
    root.querySelectorAll('[data-tnl-filters]').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const grid = document.getElementById(bar.getAttribute('aria-controls'));
      if (!grid) return;
      bar.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-k]');
        if (!btn) return;
        const k = btn.dataset.k;
        bar.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        grid.querySelectorAll('[data-k]').forEach((card) => {
          card.hidden = !(k === '*' || card.dataset.k === k);
        });
      });
    });
  }
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
